import { logError } from 'client/javascript/util/logger';
import getClosestMarket from 'client/javascript/get_closest_market';
import { trackInteraction, EventNameTypes, makeSegmentTrackCall } from 'client/javascript/analytics';
import { ROLLBAR_LOGGING_PREFIX } from 'client/javascript/pages/shared/sections/hero_container';

const NUMBER_OF_RESULTS = 1;
const PAGE_ELEMENT = 'hero module';

export const CLASSES = {
  HERO_IMAGE: 'hero__image-item',
  HERO_IMAGE_HIDE: 'hero__image-item--hide',
  HERO_IMAGE_ACTIVE: 'hero__image-item--active'
};

export const SELECTORS = {
  MODULE: '.hero__wrapper',
  MODULE_LOCATION_LINK: '.hero__location-link',
  MODULE_SECONDARY_LINK: '.hero__cta-btn--secondary',
  MODULE_IMAGE_WRAPPER: '.hero__image-wrapper',
  MODULE_IMAGE: `.${CLASSES.HERO_IMAGE}`,
  MODULE_DEFAULT_IMAGE: `picture .${CLASSES.HERO_IMAGE}`
};
const TRACKING_SELECTORS = {
  INTERACTION: '[data-interaction-tracking-label]'
};

async function getClosestMarketSlug() {
  const closestMarket = (await getClosestMarket(NUMBER_OF_RESULTS)) || {};
  return closestMarket.slug;
}

export async function setupHeroModule() {
  try {
    const moduleDomNode = document.querySelector(SELECTORS.MODULE);

    if (!moduleDomNode) {
      return;
    }

    setupAnalytics(moduleDomNode);
    await setupHeroLocationLinkWithSlug(moduleDomNode);
  } catch (error) {
    logError(`${ROLLBAR_LOGGING_PREFIX} setupHeroModule failed: ${error.message}`, error);
  }
}

export async function setupHeroLocationLinkWithSlug(moduleDomNode) {
  try {
    const linkDomNode = moduleDomNode.querySelector(SELECTORS.MODULE_LOCATION_LINK);

    if (linkDomNode) {
      const closestMarketSlug = await getClosestMarketSlug();
      linkDomNode.search = linkDomNode.search.replace('slug=', `slug=${closestMarketSlug}`);
    }
  } catch (error) {
    logError(`${ROLLBAR_LOGGING_PREFIX} setupHeroLocationLinkWithSlug failed: ${error.message}`, error);
  }
}

export function setupAnalytics(moduleDomNode) {
  const primaryLinkDomNode = moduleDomNode.querySelector(SELECTORS.MODULE_LOCATION_LINK);
  const secondaryCTADomNode = moduleDomNode.querySelector(
    `${SELECTORS.MODULE_SECONDARY_LINK}${TRACKING_SELECTORS.INTERACTION}`
  );
  const pageType = document.documentElement.className;

  if (primaryLinkDomNode) {
    primaryLinkDomNode.addEventListener('click', () => {
      makeSegmentTrackCall(EventNameTypes.startSearch, {
        page_element: PAGE_ELEMENT,
        page_type: pageType
      });
    });
  }

  if (secondaryCTADomNode) {
    const { interactionTrackingLabel } = secondaryCTADomNode.dataset;
    secondaryCTADomNode.addEventListener('click', () => {
      trackInteraction({ label: `Click - ${interactionTrackingLabel}`, page_type: pageType });
    });
  }
}
